import { getDefaultHost, getCMSHost } from '@utils/api-helper/host';

const getData = async (url, isCMS = true, authorization) => {
  const baseURL = isCMS ? getCMSHost() : getDefaultHost();

  try {
    const response = await fetch(
      `${baseURL}${url}`,
      authorization
        ? { headers: { authorization: `Bearer ${authorization}` } }
        : undefined
    );
    if (response.ok) {
      const json = await response.json();
      return json;
    }
  } catch (error) {
    return error;
  }
};

export default getData;
